// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';
import { Label } from '@americanexpress/dls-react'; // eslint-disable-line no-unused-vars
import { FxComponentWrapper } from 'axp-fx-common'; // eslint-disable-line no-unused-vars
import ContainerCard from '../Containers/ContainerCard'; // eslint-disable-line no-unused-vars

const CardPrimary = ({
  cardData, columns, isError, isLoading,
}) => {
  const rows = [...new Array(Math.ceil(cardData.length / columns))];

  const dataRows = rows.map((_row, idx) => cardData.slice(idx * 4, idx * 4 + 4));

  const content = dataRows.map((row) => (
    <div className="row stack text-wrap" key={row}>
      {row.map((data) => (
        <div className={data.className || 'col-xs-12 col-lg-3'} key={data.id}>
          {!data.isComponent ? (
            <>
              <Label id={data.id} htmlFor={data.id}>
                {data.label}
              </Label>
              <br />
              {data.value || '__'}
            </>
          ) : data.value }
        </div>
      ))}
    </div>
  ));

  return (
    <ContainerCard>
      <FxComponentWrapper isError={isError} isLoading={isLoading} loadedComponent={content} />
    </ContainerCard>
  );
};

CardPrimary.propTypes = {
  cardData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node], PropTypes.string).isRequired,
      className: PropTypes.string,
    })
  ).isRequired,
  columns: PropTypes.number,
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
};

CardPrimary.defaultProps = {
  columns: 4,
  isError: false,
  isLoading: false,
};

export default CardPrimary;
